module.exports = __webpack_public_path__ + "img/1.b81ba01a.png";